module.exports = __webpack_public_path__ + "fonts/GretaSansH-L-Bold.3e2b0e05.otf";